export enum TargetType {
  ROOT, GROUP, USER, CLIENT
}


export const TargetTypes = [
  {
    value: TargetType[TargetType.ROOT],
    label: '전사'
  },
  {
    value: TargetType[TargetType.GROUP],
    label: '그룹'
  },
  {
    value: TargetType[TargetType.USER],
    label: '사용자'
  },
  {
    value: TargetType[TargetType.CLIENT],
    label: '컴퓨터'
  }
];
